import React from 'react'

const FilterSelect = (props) => (
  <svg width="20" height="16" viewBox="0 0 20 16" fill={props.color ? props.color : '#000000'}
       className={props.className ? props.className : ''} xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M11 8C9.13616 8 7.57006 6.72523 7.12602 5H0V3H7.12602C7.57006 1.27477 9.13616 0 11 0C13.2091 0 15 1.79086 15 4C15 6.20914 13.2091 8 11 8ZM13 4C13 5.10457 12.1046 6 11 6C9.89543 6 9 5.10457 9 4C9 2.89543 9.89543 2 11 2C12.1046 2 13 2.89543 13 4Z"
          fillOpacity="0.5"/>
    <path d="M16 3H20V5H16V3Z" fillOpacity="0.5"/>
    <path fillRule="evenodd" clipRule="evenodd"
          d="M6 16C4.13616 16 2.57006 14.7252 2.12602 13H0V11H2.12602C2.57006 9.27477 4.13616 8 6 8C8.20914 8 10 9.79086 10 12C10 14.2091 8.20914 16 6 16ZM8 12C8 13.1046 7.10457 14 6 14C4.89543 14 4 13.1046 4 12C4 10.8954 4.89543 10 6 10C7.10457 10 8 10.8954 8 12Z"
          fillOpacity="0.5"/>
    <path d="M11 13H20V11H11V13Z" fillOpacity="0.5"/>
  </svg>
)

export default FilterSelect
